import messageCreatedSound from '../assets/message-created.mp3';

export function checkIsMuted(isMutedIndefinite?: boolean | null, mutedUntil?: Date | null): boolean {
  if (isMutedIndefinite) {
    return true;
  }

  if (!mutedUntil) {
    return false;
  }

  return mutedUntil > new Date();
}

export function playSound(): void {
  try {
    new Audio(messageCreatedSound).play();
  }
  catch {
    console.error('Something went wrong with playing the new message sound');
  }
}
